import * as React from 'react';
import DocumentTitle from 'react-document-title';

import { Header } from '../components/header';
import { AllUsers } from '../containers/all-users';

export const AllUsersPage = () => (
    <DocumentTitle title="Users">
        <div id="container">
            <Header title="Users" />
            <div id="content" className="flex-fill">
                <AllUsers />
            </div>
        </div>
    </DocumentTitle>
);
